/* Savvy Electrics, Night and day (SE-ND03). Small helpers shared by the se- sections. No libraries.
   1. "Add to basket" forms ([data-nd-buy]) add without leaving the page, then say so (copy 7.2). Without
      JavaScript the same form posts to Shopify and opens the basket page.
   2. Links to #check open the window check as a sheet when the page has one (dialog#check). */
(function () {
  'use strict';

  function cartUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + path;
  }

  function announceCount() {
    return fetch(cartUrl('/cart.js'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('nd:cart', { detail: { count: cart.item_count } }));
      })
      .catch(function () {});
  }

  function message(form, ok, text) {
    var box = form.querySelector('.nd-buy__msg');
    if (!box) return;
    var d = form.dataset;
    box.hidden = false;
    box.textContent = '';
    var p = document.createElement('p');
    p.textContent = text || (ok ? d.added : d.failed);
    box.appendChild(p);
    if (ok) {
      var row = document.createElement('p');
      row.className = 'nd-buy__links';
      [[d.basketUrl, d.viewBasket], [d.checkoutUrl, d.checkOut]].forEach(function (l) {
        var a = document.createElement('a');
        a.className = 'nd-link';
        a.href = l[0];
        a.textContent = l[1];
        row.appendChild(a);
      });
      box.appendChild(row);
    }
  }

  /* SE-FB39: on success the button says "Added" with a tick for a moment, then goes back */
  function flash(btn, text) {
    if (!btn || btn.dataset.flashing) return;
    btn.dataset.flashing = '1';
    var keep = btn.innerHTML;
    btn.innerHTML = '<span class="nd-buy__tick"><svg viewBox="0 0 14 14" width="14" height="14" aria-hidden="true"><path d="M2 7.5l3.2 3L12 3.5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>' + text + '</span>';
    setTimeout(function () { btn.innerHTML = keep; delete btn.dataset.flashing; }, 1400);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-nd-buy]');
    if (!form || !window.fetch || !window.FormData) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    fetch(cartUrl('/cart/add.js'), { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (r.ok) { message(form, true); announceCount(); flash(btn, 'Added'); return; }
        /* 422: Shopify won't add more (stock or a quantity limit): use the copy's words with Shopify's number */
        return r.json().then(function (j) {
          var n = String((j && j.description) || '').match(/\d+/);
          message(form, false, r.status === 422 && n && form.dataset.limit ? form.dataset.limit.replace('{n}', n[0]) : null);
        }, function () { message(form, false); });
      })
      .catch(function () { message(form, false); })
      .then(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; } });
  });

  /* window check as a sheet */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href$="#check"]');
    if (!a) return;
    var sheet = document.getElementById('check');
    if (!sheet || sheet.tagName !== 'DIALOG' || typeof sheet.showModal !== 'function') return;
    var url = new URL(a.href, location.href);
    if (url.pathname !== location.pathname && url.pathname !== '/') return;
    e.preventDefault();
    sheet.showModal();
  });
  document.addEventListener('click', function (e) {
    var d = e.target;
    if (d.tagName === 'DIALOG' && d.classList.contains('nd-sheet')) d.close();
    var c = e.target.closest && e.target.closest('[data-nd-close]');
    if (c) c.closest('dialog').close();
  });
})();

/* Drawn clips: play only while in view, never when the visitor prefers reduced motion (SE-FB31). */
(function () {
  var vids = document.querySelectorAll('video[data-nd-clip]');
  if (!vids.length || !('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
    });
  }, { threshold: 0.2 });
  vids.forEach(function (v) { io.observe(v); });
})();
/* Rise-in: headings and tiles fade up 12 px the first time they come into view (SE-FB31). */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var els = document.querySelectorAll('.nd-h2, .nd-robots__pair > *, .nd-hl__item, .nd-part, .nd-how__list > li, .nd-cmp__scale, .nd-check__card, .nd-who__in');
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' });
  els.forEach(function (el) {
    var r = el.getBoundingClientRect();
    if (r.top < window.innerHeight * 0.9) { return; } /* already on screen: no animation on load */
    el.classList.add('nd-rise'); io.observe(el);
  });
})();
